import type { HeaderProps } from '../types';

/**
 * Top bar: 64 px, white, title on the left, actions on the right, a menu button on small screens.
 */
export const Header = ({ title, actions, onOpenNavigation }: HeaderProps) => (
  <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 md:px-6">
    <div className="flex items-center gap-3">
      {onOpenNavigation ? (
        <button
          type="button"
          onClick={onOpenNavigation}
          aria-label="Abrir navegación"
          className="control-touch flex min-w-11 items-center justify-center rounded-control p-2 text-gray-500 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300 md:hidden"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      ) : null}
      {title ? <div className="text-sm font-medium text-gray-700">{title}</div> : null}
    </div>
    <div className="flex items-center gap-3">{actions}</div>
  </header>
);
